<script setup lang="ts">
import type { DetectionFilters } from '@/types/filters/DetectionFilters'
import type { AssociatedDeviceModel } from '@/types/models/DeviceModel'
import { SelectorField } from '@rfc/rfc-components-library'
import { computed, ref, watch } from 'vue'

type Props = {
    filters?: DetectionFilters
    deviceOptions?: AssociatedDeviceModel[]
}
const props = defineProps<Props>()
type Emits = {
    (e: 'change', value?: AssociatedDeviceModel): void
}
defineEmits<Emits>()

const localDeviceOptions = ref<AssociatedDeviceModel[] | undefined>([])

watch(
    () => props.filters?.event_id,
    newEventId => {
        if (newEventId && props.deviceOptions?.length)
            return (localDeviceOptions.value = props.deviceOptions)
    }
)

const currentDevice = computed(() =>
    localDeviceOptions.value?.find(item => item?.device_id === props.filters?.device_id)
)
</script>

<template>
    <SelectorField
        :label="$t('detection.filters.device')"
        :modelValue="currentDevice?.name"
        itemTitle="name"
        itemValue="device_id"
        :options="localDeviceOptions ?? []"
        @select="$emit('change', $event)" />
</template>
